import React from "react";
import { Modal, TextContainer } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";

function CloseModal({ open, onClose, shopOrigin }) {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate(`/all-blogs-listing?shop=${encodeURIComponent(shopOrigin || "")}`);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Are you sure?"
      primaryAction={{
        content: "Yes",
        destructive: true,
        onAction: handleConfirm,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: onClose,
        },
      ]}
    >
      <Modal.Section>
        <TextContainer>
          <p>Do you want to go to the article list?</p>
        </TextContainer>
      </Modal.Section>
    </Modal>
  );
}

export default CloseModal;